export default __webpack_public_path__ + "static/media/assessment_hover.84fcd2c5.png";